import { connect } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import React from 'react';

import { platforms } from 'enums/app';

export const ThemeProviderContainer = connect(state => {
  const theme = state.configuration.theme;
  theme.platform = state.app.platform;
  theme.isMobile = state.app.platform === platforms.IOS || state.app.platform === platforms.ANDROID;
  return { theme };
})(ThemeProviderBase);

function ThemeProviderBase({ children, theme }) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
